import { useStoreState } from '@src/model/hooks';
import type { ContentEntityType } from '@src/store/contentEntities/model';
import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useEffect, useMemo } from 'react';
import { type ReactionCollectionCompositeKeyParams, loadMoreReactionsByEntityIdsAtom, reactionCollectionStateFamily } from '../reactions';

export interface UseMyReactionsPayload {
    entityType: ContentEntityType;
    entityId?: string;
    entityIds?: string[];
}

export const useMyReactions = (payload: UseMyReactionsPayload) => {
    const { entityType, entityId, entityIds } = payload;
    const myUserId = useStoreState(state => state.user.myUserId);
    const params: ReactionCollectionCompositeKeyParams = useMemo(
        () => ({
            type: 'user',
            entityType,
            entityId,
            entityIds,
            userId: myUserId,
        }),
        [entityType, entityId, entityIds, myUserId],
    );

    const { ids, status, error } = useAtomValue(reactionCollectionStateFamily(params));

    const triggerLoadMore = useSetAtom(loadMoreReactionsByEntityIdsAtom);

    const loadMore = useCallback(() => {
        triggerLoadMore({ ...params, entityIds });
    }, [params]);

    return {
        reactionIds: ids,
        loadMore,
        loadStatus: status,
        error,
    };
};
